var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import PackageSearchSVG from './package-search.icon.svg';
export const PackageSearchIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: PackageSearchSVG }));
_react_refresh_temp_1 = PackageSearchIcon;
$RefreshReg$(_react_refresh_temp_1, "PackageSearchIcon");
